module.exports = __webpack_public_path__ + "static/media/pic_02.da188406.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageTextCheck/pic_02.png
// module id = 593
// module chunks = 0